import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../contexts/AuthProvider";
import ModalShortlistedGreen from "../../AdminDashboard/ProcessingLeads/AdminShortListed/AdminShortListedGreen/ModalShortlistedGreen";
import JobBoardLoader from "../../Shared/pageLoaderGreen/JobBoardLoader";

const StudentSelectedTutor = () => {
  const { user } = useContext(AuthContext);
  const [InvoiceMainData, setInvoiceMainData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const fetchData = async (page) => {
    setLoading(true);
    const url = `https://tutor-tree-server-1.vercel.app/green-shortlisted-email/${user?.email}?page=${page}&limit=10`;
    const res = await fetch(url);
    let data = await res.json();
    setInvoiceMainData(data.data);
    setTotalPages(data.totalPages);
    setLoading(false);
  };

  useEffect(() => {
    fetchData(page);
  }, [user?.email, page]);

  const formatDate = (dateString) => {
    // Extract the relevant parts of the date string
    const [datePart, timePart] = dateString.split("T");
    const [year, month, day] = datePart.split("-");

    // Construct the date in DD/MM/YYYY format
    const formattedDate = `${day}/${month}/${year}`;

    return formattedDate;
  };

  const classMapping = {
    "Pre-Schooling": "Pre-Schooling",
    Play: "Play",
    Nursery: "Nursery",
    KG: "KG",
    BM1: "Class 1",
    BM2: "Class 2",
    BM3: "Class 3",
    BM4: "Class 4",
    BM5: "Class 5",
    BM6: "Class 6",
    BM7: "Class 7",
    BM8: "Class 8",
    BM9: "Class 9",
    BM10: "Class 10",
    "BMHSC-1stYear": "HSC-1st Year",
    "BMHSC-2ndYear": "HSC-2nd Year",
    EV1: "Class 1",
    EV2: "Class 2",
    EV3: "Class 3",
    EV4: "Class 4",
    EV5: "Class 5",
    EV6: "Class 6",
    EV7: "Class 7",
    EV8: "Class 8",
    EV9: "Class 9",
    EV10: "Class 10",
    "EVHSC-1stYear": "HSC-1st Year",
    "EVHSC-2stYear": "HSC-2nd Year",
    EM1: "Class 1",
    EM2: "Class 2",
    EM3: "Class 3",
    EM4: "Class 4",
    EM5: "Class 5",
    EM6: "Class 6",
    EM7: "Class 7",
    EM8: "Class 8",
    EM9: "Class 9",
    OLevel: "OLevel",
    ALevelAS: "A Level (AS)",
    ALevelA2: "A Level (A2)",
    "EMHSC-2stYear": "HSC-2nd Year",
    Alim1: "Class 1",
    Alim2: "Class 2",
    Alim3: "Class 3",
    Alim4: "Class 4",
    Alim5: "Class 5",
    Alim6: "Class 6",
    Alim7: "Class 7",
    Alim8: "Class 8",
    Alim9: "Class 9",
    Alim10: "Class 10",
    "Alim-1stYear": "Alim-1st Year",
    "Alim-2stYear": "Alim-2nd Year",
    IslamicStudies: "Islamic Studies",
    HinduismStudies: "Hinduism Studies",
    BuddhismStudies: "Buddhism Studies",
    ChristianityStudies: "Christianity Studies",
    SchoolAdmissionTest: "School Admission Test",
    PublicUniversityAdmissionTest: "Public University Admission Test",
    PrivateUniversityAdmissionTest: "Private University Admission Test",
    MedicalCollegeAdmissionTest: "Medical College Admission Test",
    EngineeringUniversityAdmissionTest: "Engineering University Admission Test",
    Arts: "Arts",
    Music: "Music",
    InstrumentalMusic: "Instrumental Music",
    Dance: "Dance",
    Crafting: "Crafting",
    Recitation: "Recitation",
    TestPreparation: "Test Preparation",
    IELTS: "IELTS",
    TOEFL: "TOEFL",
    GRE: "GRE",
    GMAT: "GMAT",
    SAT: "SAT",
    GED: "GED",
  };
  const addSpaceBeforeCapital = (text) => {
    // return text.replace(/([a-z])([A-Z])/g, '$1 $2');
  };
  const dateFormat = (dateString) => {
    // Array of month names
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Create a new Date object
    const date = new Date(dateString);

    // Extract the month, day, and year
    const month = monthNames[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();

    // Format the date as "Jul 31, 2024"
    return `${month} ${day}, ${year}`;
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="h-screen">
      {loading ? (
        <JobBoardLoader></JobBoardLoader>
      ) : (
        <div className="grid grid-cols-2 gap-5 m-5">
          {InvoiceMainData?.length > 0 ? (
            InvoiceMainData.map((apply) => (
              <div className="w-full">
                <div
                  className="w-full bg-white rounded-lg shadow-sm"
                  key={apply._id}
                >
                  <button className="w-full" onClick={openModal}>
                    <div className="p-5 flex flex-row justify-between  w-full">
                      <div className=" w-full">
                        <h1 className="text-start border-b border-green-200 mb-2 text-lg font-montserrat text-green-900 text600">
                          Job Details
                        </h1>
                        <div className="flex flex-col items-start">
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Job Id : {apply.StudentsJobID}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Student Joining Date :{" "}
                            {dateFormat(apply.StudentsJoiningDate)}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            District : {apply.StudentsDistrict}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Area : {apply.StudentsArea}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Tutor Gender : {apply.StudentsTutorGender}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Teaching Days : {apply.StudentsTeachingDays}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Salary : {apply.StudentsSalary}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1">
                            Subjects : {apply.StudentsrequiredSubject1}{" "}
                            {apply.StudentsrequiredSubject2 ? "," : ""}{" "}
                            {apply.StudentsrequiredSubject2}{" "}
                            {apply.StudentsrequiredSubject3 ? "," : ""}{" "}
                            {apply.StudentsrequiredSubject3}{" "}
                            {apply.StudentsrequiredSubject4 ? "," : ""}{" "}
                            {apply.StudentsrequiredSubject4}{" "}
                            {apply.StudentsrequiredSubject5 ? "," : ""}{" "}
                            {apply.StudentsrequiredSubject5}
                          </h1>
                        </div>
                      </div>
                      <div className="bg-white rounded-2xl shadow-xl border border-green-200 w-full p-5">
                        <h1 className="text-start mb-2 text-lg font-montserrat text-green-900 text600 pb-2 border-b border-green-400">
                         Selected applier CV
                        </h1>
                        <div className=" flex flex-col items-start">
                          <h1 className="text-md font-montserrat text-green-900 my-1 ">
                            Applying Date : {apply.applyingDate}
                          </h1>
                          <h1 className="text-md font-montserrat text-green-900 my-1 ">
                            Name : {apply.teacherName}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            Email : {apply.teacherEmail}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            Phone : {apply.phone}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            HSC Result : {apply.teacherHSCresult}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            HSC Group : {apply.teacherHSCgroup}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            Hons Institute : {apply.teacherHonsInstitute}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            Hons Major : {apply.teacherHonsMajor}
                          </h1>
                          <h1 className="text-md text-green-900 my-1 font-montserrat">
                            Hons Semester : {apply.teacherHonsSemester}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </button>
                  <div>
                    <ModalShortlistedGreen
                      apply={apply}
                      isVisible={isModalVisible}
                      onClose={closeModal}
                    />
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>No data available</p>
          )}
        </div>
      )}
      <div className="flex justify-center items-center">
        <div className="flex justify-between mt-5 w-[300px]">
          <button disabled={page <= 1} onClick={() => setPage(page - 1)}>
            <img
              className="w-10"
              alt=""
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
            />
          </button>
          <span className="text-lg font-roboto">
            Page {page} of {totalPages}
          </span>
          <button
            disabled={page >= totalPages}
            onClick={() => setPage(page + 1)}
          >
            <img
              className="w-10"
              alt=""
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StudentSelectedTutor;
